export const TOOL_CATEGORY_DEFINITIONS = [
  {
    slug: 'social-media',
    value: 'Social Media',
    labelKey: 'ui.tools.categories.socialMedia',
  },
  {
    slug: 'digital-marketing',
    value: 'Digital Marketing',
    labelKey: 'ui.tools.categories.digitalMarketing',
  },
  {
    slug: 'business-print',
    value: 'Business & Print',
    labelKey: 'ui.tools.categories.businessPrint',
  },
  {
    slug: 'stationery',
    value: 'Stationery',
    labelKey: 'ui.tools.categories.stationery',
  },
  {
    slug: 'campaigns',
    value: 'Campaigns',
    labelKey: 'ui.tools.categories.campaigns',
  },
  {
    slug: 'industries',
    value: 'Industries',
    labelKey: 'ui.tools.categories.industries',
  },
  {
    slug: 'occasions',
    value: 'Occasions',
    labelKey: 'ui.tools.categories.occasions',
  },
  {
    slug: 'workflows',
    value: 'Workflows',
    labelKey: 'ui.tools.categories.workflows',
  },
  {
    slug: 'input-methods',
    value: 'Input Methods',
    labelKey: 'ui.tools.categories.inputMethods',
  },
  {
    slug: 'roles',
    value: 'Roles',
    labelKey: 'ui.tools.categories.roles',
  },
  {
    slug: 'templates',
    value: 'Templates',
    labelKey: 'ui.tools.categories.templates',
  },
] as const satisfies ReadonlyArray<{
  slug: string;
  value: string;
  labelKey: string;
}>;

export type ToolCategoryDefinition = (typeof TOOL_CATEGORY_DEFINITIONS)[number];
export type ToolCategorySlug = ToolCategoryDefinition['slug'];
export type ToolCategoryValue = ToolCategoryDefinition['value'];

const TOOL_CATEGORY_BY_PAGE_FAMILY: Readonly<Record<string, ToolCategoryValue>> = {
  campaign: 'Campaigns',
  industry: 'Industries',
  occasion: 'Occasions',
  workflow: 'Workflows',
  input: 'Input Methods',
  role: 'Roles',
  template: 'Templates',
};

export function toolCategoryByValue(raw: unknown): ToolCategoryDefinition | null {
  if (typeof raw !== 'string') return null;
  return TOOL_CATEGORY_DEFINITIONS.find(({ value }) => value === raw.trim()) ?? null;
}

export function toolCategoryBySlug(raw: unknown): ToolCategoryDefinition | null {
  if (typeof raw !== 'string') return null;
  return TOOL_CATEGORY_DEFINITIONS.find(({ slug }) => slug === raw.trim().toLowerCase()) ?? null;
}

export function resolveToolCategory(
  rawCategory: unknown,
  rawPageFamily: unknown
): ToolCategoryDefinition {
  const familyCategory =
    typeof rawPageFamily === 'string'
      ? TOOL_CATEGORY_BY_PAGE_FAMILY[rawPageFamily.trim().toLowerCase()]
      : undefined;
  if (familyCategory) return toolCategoryByValue(familyCategory)!;

  const explicitCategory = toolCategoryByValue(rawCategory);
  if (explicitCategory) return explicitCategory;

  return toolCategoryByValue('Business & Print')!;
}

export function toolCategoryMorePath(category: ToolCategoryDefinition): string {
  return `/ai-design-tools/${category.slug}`;
}
